import { useState } from "react";
import { createClient } from "@supabase/supabase-js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Container, Button, Form } from "react-bootstrap";
import { es } from "date-fns/locale";
import { listaMasajes } from "../../assets/data/masajes";

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;
const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY);

const AdminCrearCitas = ({ onCitaCreada }) => {
    const [nombre, setNombre] = useState("");
    const [primerApellido, setPrimerApellido] = useState("");
    const [segundoApellido, setSegundoApellido] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const [tipoMasaje, setTipoMasaje] = useState("");
    const [hora, setHora] = useState(new Date());
    const [comentario, setComentario] = useState("");
    const [duracion, setDuracion] = useState(60);

    const agregarCita = async () => {
        if (!nombre || !telefono || !tipoMasaje) {
            alert("Completa al menos nombre, teléfono y tipo de masaje.");
            return;
        }

        const fechaLocal = new Date(hora);
        const offsetMs = fechaLocal.getTimezoneOffset() * 60000;
        const horaISO = new Date(fechaLocal.getTime() - offsetMs)
            .toISOString()
            .slice(0, 19);

        const { error } = await supabase.from("citas").insert([
            {
                nombre,
                primer_apellido: primerApellido,
                segundo_apellido: segundoApellido,
                telefono,
                email,
                tipo_de_masaje: tipoMasaje,
                duracion,
                comentario_cliente: comentario,
                hora: horaISO,
                confirmada: true,
                ha_pagado: false,
            },
        ]);

        if (error) {
            alert("Error al agregar cita: " + error.message);
        } else {
            onCitaCreada?.(); // notifica al padre para refrescar
            setNombre("");
            setPrimerApellido("");
            setSegundoApellido("");
            setTelefono("");
            setEmail("");
            setTipoMasaje("");
            setHora(new Date());
            setComentario("");
            setDuracion(60);
        }
    };

    const generarIdFicticio = (fecha) => {
        const d = new Date(fecha);

        const dia = String(d.getDate()).padStart(2, "0");
        const mes = String(d.getMonth() + 1).padStart(2, "0");
        const hora = String(d.getHours()).padStart(2, "0");
        const minutos = String(d.getMinutes()).padStart(2, "0");

        return `${dia}-${mes}-${hora}:${minutos}`;
    };


    const crearCitaFicticia = async () => {
        const fechaLocal = new Date(hora);
        const offsetMs = fechaLocal.getTimezoneOffset() * 60000;
        const horaISO = new Date(fechaLocal.getTime() - offsetMs)
            .toISOString()
            .slice(0, 19);

        const id = generarIdFicticio(hora);

        const { error } = await supabase.from("citas").insert([
            {
                nombre: `FICTICIO ${id}`,
                primer_apellido: "",
                segundo_apellido: "",
                telefono: "000000000",
                email: "",
                tipo_de_masaje: "Bloqueado",
                duracion,
                comentario_cliente: "Cita ficticia para bloquear hueco",
                hora: horaISO,
                confirmada: true,
                ha_pagado: false,
            },
        ]);

        if (error) {
            alert("Error al crear cita ficticia: " + error.message);
        } else {
            alert("Cita ficticia creada");
            onCitaCreada?.();
            // mantenemos la hora seleccionada
        }
    };



    const eliminarCitasFicticias = async () => {
        const confirmar = window.confirm(
            "Esto eliminará TODAS las citas cuyo nombre contenga 'fict'. ¿Seguro?"
        );

        if (!confirmar) return;

        const { data, error } = await supabase
            .from("citas")
            .delete()
            .ilike("nombre", "%fict%");   // <-- busca fict en cualquier parte, sin importar mayúsculas

        if (error) {
            alert("Error al eliminar citas ficticias: " + error.message);
        } else {
            alert("Citas ficticias eliminadas correctamente");
            onCitaCreada?.(); // refresca la lista en el componente padre
        }
    };


    return (
        <div style={{ marginTop: "30px", width: "40%" }}>
            <h3 style={{ fontSize: "2rem", marginTop: "1.5rem" }}>Crear cita</h3>
            <div
                style={{
                    display: "grid",
                    gap: "10px",
                    marginBottom: "20px",
                    background: "#fff",
                    padding: "20px",
                }}
            >
                <Form.Control
                    placeholder="Nombre"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                />
                <Form.Control
                    placeholder="Primer apellido"
                    value={primerApellido}
                    onChange={(e) => setPrimerApellido(e.target.value)}
                />
                <Form.Control
                    placeholder="Segundo apellido"
                    value={segundoApellido}
                    onChange={(e) => setSegundoApellido(e.target.value)}
                />
                <Form.Control
                    placeholder="Teléfono"
                    value={telefono}
                    onChange={(e) => setTelefono(e.target.value)}
                    required
                />
                <Form.Control
                    type="email"
                    placeholder="Email (opcional)"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Form.Select
                    value={tipoMasaje}
                    onChange={(e) => setTipoMasaje(e.target.value)}
                    required
                >
                    <option value="">Selecciona tipo de masaje</option>
                    {listaMasajes.map((masaje, index) => (
                        <option key={index} value={masaje.altTitle}>
                            {masaje.altTitle} – {masaje.precio} €
                        </option>
                    ))}
                </Form.Select>

                <Form.Control
                    type="number"
                    placeholder="Duración en minutos (por defecto 60)"
                    min={30}
                    step={15}
                    value={duracion}
                    onChange={(e) => setDuracion(Number(e.target.value))}
                />
                <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Comentario del cliente (opcional)"
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                />

                <div>
                    <label style={{ fontSize: ".9rem", color: "#555" }}>
                        Fecha y hora de la cita:
                    </label>
                    <DatePicker
                        locale={es}
                        selected={hora}
                        onChange={(date) => setHora(date)}
                        showTimeSelect
                        timeIntervals={30}
                        dateFormat="yyyy-MM-dd HH:mm"
                        className="form-control"
                    />
                </div>

                <Button variant="primary" onClick={agregarCita} style={{ width: "200px" }}>
                    Guardar cita
                </Button>

                <Button
                    variant="warning"
                    onClick={crearCitaFicticia}
                    style={{ width: "300px", marginTop: "10px" }}
                >
                    🧪 Crear cita ficticia
                </Button>


                <Button
                    variant="danger"
                    onClick={eliminarCitasFicticias}
                    style={{ width: "300px", marginTop: "10px" }}
                >
                    🗑️ Eliminar citas ficticias
                </Button>

            </div>
        </div>
    );
};

export default AdminCrearCitas;
